import React from 'react'
import {Text, View, StyleSheet, Page, Document, Image, PDFDownloadLink, Font} from "@react-pdf/renderer";
// import logo from '../assets/logo.png';
import {useSelector} from 'react-redux';
import {formatNum} from '../services/base';
import NotoSans from '../assets/NotoSans.ttf'
Font.register({family: 'Noto Sans', src: NotoSans});
const styles = StyleSheet.create({
	body: {
		padding: 30,
		fontSize: 13,
		fontFamily: 'Noto Sans',
		color: "#47484A"
	},
	table: {
		display: "table",
		width: '100%',
		borderStyle: "solid",
		borderWidth: 1,
		borderRightWidth: 0,
		borderBottomWidth: 0,
		borderColor: '#ccc',
	},
	acctTable: {
		display: "table",
		width: '50%',
		borderStyle: "solid",
		borderWidth: 1,
		borderRightWidth: 0,
		borderBottomWidth: 0,
		borderColor: '#ccc',
	},
	tableRow: {
		margin: "auto",
		flexDirection: "row",
		display: 'flex',
	},
	tableRowHead: {
		backgroundColor: '#F8F8F8',
		margin: "auto",
		flexDirection: "row",
		display: 'flex',
	},
	tableCol: {
		borderStyle: "solid",
		borderWidth: 1,
		borderColor: '#ccc',
		borderLeftWidth: 0,
		borderTopWidth: 0,
	},
	tableCell: {
		margin: 10,
		fontWeight: 'bold'
	},
	logo: {
		width: 80,
		height: 40,
		border: '1 solid black'
	},
	head: {
		display: 'flex',
		flexDirection: 'column',
		gap: 5
	},
	footer: {
		border: '1 dotted #ccc',
		borderRightWidth: 0,
		borderLeftWidth: 0,
		paddingVertical: 10,
		gap: 2,
		fontSize: 7,
		display: 'flex',
		flexDirection: 'column'
	}
});

const CustomPDF = ({details, leftDetails, rightDetails}) => {
	const {
		// data, customer,
		company
	} = useSelector(state => state.profile);
	// const isCORP = (customer?.label === "CORP");
	return (
		<>
			<PDFDownloadLink document={
				<Document>
					<Page size={'A2'}>
						<View style={styles.body}>
							<View style={styles.head}>
								<Image src={company.logo} style={{width: 150, marginLeft: 'auto'}} />
								<Text style={{fontWeight: 'bold', textAlign: "center", fontSize: "32px"}}>Account Statement</Text>
								<Text style={{fontWeight: 'bold', textAlign: "center"}}>Generated on {new Date().toDateString()} {new Date().toLocaleTimeString()}</Text>

								<View style={{display: 'flex', flexDirection: "row", gap: 20, marginTop: "32px"}}>
									<View style={{...styles.acctTable, flex: 2}}>
										{
											Object.keys(leftDetails).map((each, i) => (
												<View key={each + "left"} style={{...styles.tableRow, backgroundColor: i % 2 ? "#F8F8F8" : "#fff"}}>
													<View style={{...styles.tableCol, width: '35%'}}>
														<Text style={styles.tableCell}>{each}</Text>
													</View>
													<View style={{...styles.tableCol, width: '65%'}}>
														<Text style={styles.tableCell}>{leftDetails[each]}</Text>
													</View>
												</View>
											))
										}
									</View>

									<View style={{...styles.acctTable, flex: 1}}>
										{
											Object.keys(rightDetails).map((each, i) => (
												<View key={each} style={{...styles.tableRow, backgroundColor: i % 2 ? "#F8F8F8" : "#fff"}}>
													<View style={{...styles.tableCol, width: '60%'}}>
														<Text style={styles.tableCell}>{each}</Text>
													</View>
													<View style={{...styles.tableCol, width: '40%'}}>
														<Text style={styles.tableCell}>{rightDetails[each]}</Text>
													</View>
												</View>
											))
										}
									</View>

								</View>

								<Text style={{fontWeight: 'bold', textAlign: "center", fontSize: "32px", marginVertical: "32px"}}>Transaction Statement</Text>

								<View style={styles.table}>
									<View style={styles.tableRowHead}>
										<View style={{...styles.tableCol, width: '17%'}}>
											<Text style={{...styles.tableCell, fontWeight: "black"}}>Transaction Date</Text>
										</View>
										<View style={{...styles.tableCol, width: '25%'}}>
											<Text style={{...styles.tableCell, fontWeight: "black"}}>Transaction ID</Text>
										</View>
										<View style={{...styles.tableCol, width: '15%'}}>
											<Text style={{...styles.tableCell, fontWeight: "black"}}>Amount</Text>
										</View>
										{/* <View style={{...styles.tableCol, width: '7%'}}>
											<Text style={styles.tableCell}>Currency</Text>
										</View> */}
										<View style={{...styles.tableCol, width: '28%'}}>
											<Text style={{...styles.tableCell, fontWeight: "black"}}>Narration</Text>
										</View>
										<View style={{...styles.tableCol, width: '15%'}}>
											<Text style={{...styles.tableCell, fontWeight: "black"}}>Status</Text>
										</View>
										{/* <View style={{...styles.tableCol, width: '20%'}}>
											<Text style={styles.tableCell}>Remark</Text>
										</View> */}
									</View>
									{
										details.map((each, i) => (
											<View style={{...styles.tableRow, backgroundColor: i % 2 ? "#F8F8F8" : "#fff"}}>
												<View style={{...styles.tableCol, width: '17%'}}>
													<Text style={styles.tableCell}>{new Date(each.created_at).toDateString()}</Text>
												</View>
												<View style={{...styles.tableCol, width: '25%'}}>
													<Text style={styles.tableCell}>{each.tran_id}</Text>
												</View>
												<View style={{...styles.tableCol, width: '15%'}}>
													<Text style={styles.tableCell}>{each.currency === 'USD' ? '$' : '₦'} {formatNum(each.amount)}</Text>
												</View>
												{/* <View style={{...styles.tableCol, width: '7%'}}>
													<Text style={styles.tableCell}>{each.currency}</Text>
												</View> */}
												<View style={{...styles.tableCol, width: '28%'}}>
													<Text style={styles.tableCell}>{each.action}</Text>
												</View>
												<View style={{...styles.tableCol, width: '15%'}}>
													<Text style={{
														...styles.tableCell, color: each.status.toLowerCase() === "pending" ? 'orange' :
															each.status.toLowerCase() === "approved" ? 'green' :
																each.status.toLowerCase() === "rejected" ? 'red' :
																	'#000'
														, textTransform: 'capitalize'
													}}>{each.status.toLowerCase()}</Text>
												</View>
												{/* <View style={{...styles.tableCol, width: '20%'}}>
													<Text style={styles.tableCell}>{each.system_message}</Text>
												</View> */}
											</View>
										))
									}
								</View>
								<Text style={{fontSize: 7}}>-</Text>
								<Text style={{margin: 'auto', fontSize: 7}}>** This is an electronically generated certificate and requires no signature. **</Text>
							</View>
						</View>
					</Page>
				</Document>
			} fileName={`Account Statement`} className=''>
				Download Statement
			</PDFDownloadLink>
		</>
	)
}

export default CustomPDF